import { useEffect, useState } from 'react';
import { getNextWeek, getPreviousWeek, getWeekDates } from '../utils/dateUtils';

/**
 * Custom hook for managing week navigation state
 */
export const useWeekNavigation = () => {
  const [currentWeek, setCurrentWeek] = useState<Date>(new Date());
  const [currentWeekDates, setCurrentWeekDates] = useState<Date[]>([]);
  const [previousWeekDates, setPreviousWeekDates] = useState<Date[]>([]);
  const [nextWeekDates, setNextWeekDates] = useState<Date[]>([]);

  useEffect(() => {
    const currentDates = getWeekDates(currentWeek);
    const previousDates = getWeekDates(getPreviousWeek(currentWeek));
    const nextDates = getWeekDates(getNextWeek(currentWeek));

    setCurrentWeekDates(currentDates);
    setPreviousWeekDates(previousDates);
    setNextWeekDates(nextDates);
  }, [currentWeek]);

  return {
    currentWeek,
    setCurrentWeek,
    currentWeekDates,
    previousWeekDates,
    nextWeekDates,
  };
};
